import { useContext } from 'react'
import { ReportSourceContext } from '../Contexts/ReportSourceProvider'

export const useInstitution = () => {
  const context = useContext(ReportSourceContext)
  return context
}
